import { assertFormGqlOperation, UseFormReturn } from '@graphcommerce/react-hook-form'
import { Trans } from '@lingui/react'
import { Switch } from '@mui/material'
import { Dropdown } from '../../Dropdown'

type FreightFieldValues = {
  can_accept_pallets?: boolean
  appointment_required?: boolean
  loading_dock?: boolean
  delivery_to_door?: boolean
  limited_access_delivery?: boolean
  residential_delivery?: boolean
  days_hours_delivery?: { label?: string; available?: boolean; from: string; to: string }[]
}

type FreightFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>
}

const hourRange = [...Array(12).keys()]

export function FreightFields(props: FreightFieldProps) {
  const { form } = props
  assertFormGqlOperation<FreightFieldValues>(form)

  const { watch, register, setValue } = form
  const daysHoursDelivery = watch('days_hours_delivery')

  return (
    <div className='flex flex-col gap-1'>
      <div className='grid grid-cols-[10fr_15fr_75fr] items-center'>
        <span>{watch('appointment_required') === true ? 'Yes' : 'No'}</span>
        <Switch
          checked={watch('appointment_required', true)}
          {...register('appointment_required')}
        />
        <span className='Type-Large-Medium'>
          <Trans id='Appointment Required*' />
        </span>
      </div>
      <div className='grid grid-cols-[10fr_15fr_75fr] items-center'>
        <span>{watch('loading_dock') === true ? 'Yes' : 'No'}</span>
        <Switch checked={watch('loading_dock')} {...register('loading_dock')} />
        <span className='Type-Large-Medium'>
          <Trans id='There is a loading dock*' />
        </span>
      </div>
      <div className='grid grid-cols-[10fr_15fr_75fr] items-center'>
        <span>{watch('delivery_to_door') === true ? 'Yes' : 'No'}</span>
        <Switch checked={watch('delivery_to_door')} {...register('delivery_to_door')} />
        <span className='Type-Large-Medium'>
          <Trans id='Delivery to door*' />
        </span>
      </div>
      <div className='grid grid-cols-[10fr_15fr_75fr] items-center'>
        <span>{watch('limited_access_delivery') === true ? 'Yes' : 'No'}</span>
        <Switch
          checked={watch('limited_access_delivery')}
          {...register('limited_access_delivery')}
          onChange={(e) => {
            if (e.target.checked) setValue('residential_delivery', false)
            setValue('limited_access_delivery', e.target.checked)
          }}
        />
        <span className='Type-Large-Medium'>
          <Trans id='Limited Access Delivery*' />
        </span>
      </div>
      <div className=''>
        <p className='Type-XL-Medium mb-4 mt-3'>
          <Trans id='Days / Hours Delivery can be made:' />
        </p>
        <div>
          {daysHoursDelivery?.map(({ label, available, from, to }, index) => (
            <div className='mb-2 grid grid-cols-[15fr_15fr_30fr_10fr_30fr] items-center'>
              <span className='Type-Large-Medium'>{label}</span>
              <div>
                <Switch
                  checked={available || false}
                  onChange={(e) => {
                    setValue(`days_hours_delivery.${index}.available`, e.target.checked)
                  }}
                />
              </div>
              <div>
                <Dropdown
                  className='Type-Large-Medium max-w-[110px]'
                  showLabel={false}
                  options={[
                    ...hourRange.map((hour) => ({
                      label: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00am`,
                      value: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00am`,
                    })),
                    ...hourRange.map((hour) => ({
                      label: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00pm`,
                      value: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00pm`,
                    })),
                  ]}
                  value={from}
                  optionLabelCountInMainArea={1}
                  onChange={(option) => {
                    if (option && typeof option.value === 'string')
                      setValue(`days_hours_delivery.${index}.from`, option.value)
                  }}
                />
              </div>
              <span className='Type-Large-Medium px-[6px] text-center align-middle'>
                <Trans id='To' />
              </span>
              <div>
                <Dropdown
                  className='Type-Large-Medium max-w-[110px]'
                  showLabel={false}
                  options={[
                    ...hourRange.map((hour) => ({
                      label: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00am`,
                      value: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00am`,
                    })),
                    ...hourRange.map((hour) => ({
                      label: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00pm`,
                      value: `${hour.toLocaleString().length === 1 ? `0${hour}` : hour}:00pm`,
                    })),
                  ]}
                  value={to}
                  onChange={(option) => {
                    if (option && typeof option.value === 'string')
                      setValue(`days_hours_delivery.${index}.to`, option.value)
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
